/* Material story — fold the tail of the story behind Read more / Read less.

   The story arrives as one flat run of rich-text nodes, so there is nothing to
   address individually. Folding therefore happens per *block*: a block is a
   label (a heading, or a paragraph made only of bold text) plus whatever
   follows it until the next label. The first N labels stay visible — the Nth
   being the last line the reader sees — and the body of that Nth block, plus
   every block after it, is hidden. So the collapsed story ends on a section
   heading rather than on a section of prose.

   Anchoring on labels rather than on a paragraph count means the same script
   works for both story conventions in the store — the older ones use
   <h2>Formation & Origins</h2>-style headings, the newer ones use bold
   paragraphs — and keeps the cut on a block boundary instead of slicing a
   section in half.

   The button ships hidden and is only revealed when something was actually
   folded, so a short story never shows a dead "Read more". */

(function () {
  'use strict';

  function isLabel(el) {
    if (/^H[1-6]$/.test(el.tagName)) return true;
    if (el.tagName !== 'P' || el.children.length !== 1) return false;
    var child = el.children[0];
    if (!/^(STRONG|B)$/.test(child.tagName)) return false;
    return el.textContent.trim() === child.textContent.trim();
  }

  function setup(section) {
    if (!section || section.dataset.mstoryReady === '1') return;

    var body = section.querySelector('[data-mstory-body]');
    var toggle = section.querySelector('[data-mstory-toggle]');
    if (!body || !toggle) return;

    var keep = parseInt(section.getAttribute('data-mstory-keep'), 10);
    if (!keep || keep < 1) keep = 2;

    /* metafield_tag wraps rich text in a <div>, so the nodes are one level
       down. Walk to whichever element actually holds them rather than
       assuming a depth. */
    var list = body;
    var inner = body.querySelector('.metafield-rich_text_field') || body.querySelector('div');
    if (inner && inner.children.length > list.children.length) list = inner;

    var nodes = Array.prototype.slice.call(list.children);
    var labels = [];
    nodes.forEach(function (el, i) { if (isLabel(el)) labels.push(i); });

    var cut;
    if (labels.length > keep) {
      /* Keep the Nth label as the last visible line, then fold from its body
         onward. Cutting at the label (rather than at the next label) is what
         makes the collapsed story end on a heading instead of a paragraph. */
      cut = labels[keep - 1] + 1;
    } else if (!labels.length) {
      cut = keep;                  /* no labels anywhere — fall back to counting */
    } else {
      return;                      /* everything already fits */
    }

    var tail = nodes.slice(cut);
    if (!tail.length) return;

    section.dataset.mstoryReady = '1';

    var moreLabel = toggle.getAttribute('data-label-more') || 'Read more';
    var lessLabel = toggle.getAttribute('data-label-less') || 'Read less';

    /* When the fold lands right after a heading there is no trailing prose to
       soften, and the fade would only wash the heading out — so skip it. */
    var endsOnLabel = isLabel(nodes[cut - 1]);

    tail.forEach(function (el) { el.classList.add('is-folded'); });
    if (!endsOnLabel) body.classList.add('is-clipped');
    toggle.hidden = false;
    toggle.textContent = moreLabel;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var next = !expanded;

      if (!endsOnLabel) body.classList.toggle('is-clipped', !next);
      tail.forEach(function (el) { el.classList.toggle('is-folded', !next); });
      toggle.setAttribute('aria-expanded', String(next));
      toggle.textContent = next ? lessLabel : moreLabel;

      /* Collapsing from the bottom of a long story leaves the reader staring at
         the footer. Bring the section back into view on close. */
      if (!next && section.scrollIntoView) {
        section.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-mstory]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Re-init when the theme editor re-renders the section. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
